import {
  Grid,
  IconArrowLeft,
  IconEdit,
  IconLogoPowerpoint,
  IconRobot,
  spacing,
  styled,
  useTranslation,
} from '@lessonup/ui-components';
import React from 'react';
import { TRANSLATION_NAMESPACE } from '../constants';
import { Footer } from './Footer';
import { LessonModalMainWrapper } from './LayoutComponents';
import { OptionCard } from './OptionCard';

interface ChooseEditorProps {
  onSelect: (editor: 'ai' | 'lesson' | 'sdi') => void;
  back: () => void;
}

export const ChooseNewEditorMode: React.FC<ChooseEditorProps> = ({ onSelect, back }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE, { keyPrefix: 'chooseNewEditorMode' });

  return (
    <LessonModalMainWrapper>
      <StyledWrapper>
        <StyledGrid cols={2} gap={spacing.size8}>
          <OptionCard
            title={t('fromScratchTitle')}
            titleIcon={<IconEdit />}
            description={t('fromScratchDescription')}
            onClick={() => onSelect('lesson')}
          />
          <OptionCard
            title={t('sdiTitle')}
            titleIcon={<IconLogoPowerpoint />}
            description={t('sdiDescription')}
            onClick={() => onSelect('sdi')}
          />
          <OptionCard
            title={t('aiTitle')}
            titleIcon={<IconRobot />}
            description={t('aiDescription')}
            onClick={() => onSelect('ai')}
          />
        </StyledGrid>
      </StyledWrapper>
      <Footer backButton={{ onClick: back, label: t('back'), iconStart: <IconArrowLeft /> }} />
    </LessonModalMainWrapper>
  );
};

const StyledGrid = styled(Grid)`
  margin: 0 ${spacing.size16} ${spacing.size16};
`;

const StyledWrapper = styled.div`
  height: 100%;
`;
